import React, { useRef, useState } from "react";
import { toJpeg } from "html-to-image";

interface IUseSavePoster {
  saveCb?: (data: string) => void;
  saveBefore?: () => void; //保存之前的检查
}
export default function (props?: IUseSavePoster) {
  const posterMainRef = useRef<HTMLDivElement>(null);

  const [builtDataUrl, setBuiltDataUrl] = useState(""); //生成的图片信息
  const [preview, setPreview] = useState(false);

  const buildImg = async function () {
    if (posterMainRef.current) {
      await toJpeg(posterMainRef.current, {
        quality: 0.9,
        // 强制设定为1，避免在mobile上宽高会被*pixelRatio
        pixelRatio: 1.5,
        // width: 1125,
      });
      const dataUrl = await toJpeg(posterMainRef.current, {
        quality: 0.9,
        // 强制设定为1，避免在mobile上宽高会被*pixelRatio
        pixelRatio: 1.5,
        // width: 1125,
      });
      return dataUrl;
    } else {
      console.warn("no div to build img");
    }
    return "";
  };
  const saveImg = async function () {
    const before = props?.saveBefore?.() ?? true;
    if (!before) {
      return;
    }
    console.log("生成海报中...");
    const dataUrl = await buildImg();
    if (!dataUrl) {
      return;
    }
    console.log("生成完成");
    setPreview(true);
    setBuiltDataUrl(dataUrl);
    props?.saveCb?.(dataUrl);
  };
  return {
    posterMainRef,
    preview,
    setPreview,
    buildImg,
    saveImg,
    builtDataUrl,
  };
}
